import {NgModule} from '@angular/core';
import {environment} from "../environments/environment";
import {RouterModule, Routes} from '@angular/router';
import {AdminGuard} from './guards/admin-guard';
import {AuthGuard} from './guards/auth-guard';
import {InnerGuard} from './guards/inner.guard';
import {IndexComponent} from './components/index/index.component';
import {CargoListComponent} from './controllers/production/cargo-list/cargo-list.component';
import {PublicDetailCardComponent} from './controllers/production/public-detail-card/public-detail-card.component';
import {ExitGuard} from './guards/save-guard';
import {FileOptionsComponent} from './components/file-options/file-options.component';
import {AllAssignmentsComponent} from './components/assignments/all-assignments/all-assignments.component';
import {DetailAssignmentsComponent} from './components/assignments/detail-assignments/detail-assignments.component';
import {RegistryDocumentsComponent} from './controllers/documents/registry-documents/registry-documents.component';
import {CatalogsComponent} from './components/property-settings/catalogs/catalogs.component';
import {PropertiesComponent} from './components/property-settings/properties/properties.component';
import {SidebarSettingsComponent} from './components/sidebar-settings/sidebar-settings.component';
import {ProductsComponent} from './controllers/boxs/products/products.component';
import {StoragesComponent} from './controllers/boxs/storages/storages.component';
import {DocumentCollectionComponent} from './controllers/documents/document-collection/document-collection.component';
import {DocumentListComponent} from './controllers/documents/document-list/document-list.component';
import {CreditComponent} from './controllers/finance/credit/credit.component';
import {FactoringComponent} from './controllers/finance/factoring/factoring.component';
import {FinanceControlComponent} from './controllers/finance/finance-control/finance-control.component';
import {GarantComponent} from './controllers/finance/garant/garant.component';
import {PersonalFinanceComponent} from './controllers/finance/personal-finance/personal-finance.component';
import {ProfileControlComponent} from './controllers/project-control/profile-control/profile-control.component';
import {IndexStatisticComponent} from './controllers/statistic/index/index.component';
import {TaskDetailComponent} from './controllers/tasks/task-detail/task-detail.component';
import {TaskBoardsComponent} from './controllers/tasks/task-options/task-boards/task-boards.component';
import {TaskOptionsComponent} from './controllers/tasks/task-options/task-options.component';
import {TasksAllComponent} from './controllers/tasks/tasks-all/tasks-all.component';
import {TemplateComponent} from "./controllers/templates/template/template.component";
import {AppMTTasksTable} from './controllers/tasks/table-tasks-mt/table-tasks-mt';
import {AppGgLoginPageComponent} from './modules/gg-gateway/components/gg-login-page/gg-login-page.component';
import {AppContractFormComponent} from './modules/contracts/controller/contract-form/contract-form.component';
import {AppLayoutComponent} from './modules/layout-global/controller/layout/layout.component';
import {DocumentDetailComponent} from "./controllers/documents/document-detail/document-detail.component";
import {
    CargoTransactionListComponent
} from './controllers/production/cargo-transaction-list/cargo-transaction-list.component';
import {DetailCardComponent} from './controllers/production/detail-card/detail-card.component';
import {
    ProductionCardListComponent
} from './controllers/production/production-card-list/production-card-list.component';
import {
    GeneralProjectSettingsComponent,
} from './components/general-project-settings/general-project-settings.component';
import {
    DepartmentsControlDetailComponent,
} from './controllers/project-control/departments-control-detail/departments-control-detail.component';
import {
    DepartmentsControlListComponent,
} from './controllers/project-control/departments-control-list/departments-control-list.component';
import {
    PersonsControlDetailComponent,
} from './controllers/project-control/persons-control-detail/persons-control-detail.component';
import {
    PersonsControlListComponent,
} from './controllers/project-control/persons-control-list/persons-control-list.component';
import {AppMTContractTable} from "./modules/contracts/controller/table-contracts-mt/contract-table-mt";

const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
    },
    {
        path: 'login',
        component: AppGgLoginPageComponent,
    },
    {
        path: 'account',
        canActivate: [AuthGuard],
        component: AppLayoutComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'index',
            },
            {
                path: 'index',
                component: IndexComponent,
            },
            {
                path: 'doc',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: '/account/doc/nav',
                    },
                    {
                        path: 'nav',
                        component: DocumentListComponent,
                    },
                    {
                        path: 'nav/file/:file',
                        component: DocumentDetailComponent,
                    },
                    {
                        path: 'nav/file/:file/:version',
                        component: DocumentDetailComponent,
                    },
                    {
                        path: 'nav/:folder',
                        component: DocumentListComponent,
                    },
                    {
                        path: 'nav/:filter/:collection',
                        component: DocumentCollectionComponent,
                    },
                    {
                        path: 'settings',
                        component: FileOptionsComponent,
                    },
                    {
                        path: 'registry',
                        canActivate: [AdminGuard, InnerGuard],
                        component: RegistryDocumentsComponent,
                    },
                    {
                        path: 'registry/:etc',
                        canActivate: [AdminGuard, InnerGuard],
                        component: RegistryDocumentsComponent,
                    },
                    {
                        path: 'registry/:svc/:etc',
                        canActivate: [AdminGuard, InnerGuard],
                        component: RegistryDocumentsComponent,
                    },
                    {
                        path: ':filter',
                        component: DocumentListComponent,
                    },
                    {
                        path: ':filter/:collection',
                        component: DocumentCollectionComponent,
                    },
                ],
            },
            {
                path: 'tasks2',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all',
                    },
                    {
                        path: 'my',
                        component: AppMTTasksTable,
                        data: {reuse: true},
                        children: [
                            {
                                path: ':id',
                                component: TaskDetailComponent,
                            },
                        ],
                    },

                ],
            },
            {
                path: 'tasks',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all',
                    },
                    {
                        path: 'my',
                        children: [
                            {
                                path: '',
                                component: TasksAllComponent,
                            },
                            {
                                path: ':id',
                                component: TaskDetailComponent,
                            },
                        ],
                    },
                    {
                        path: 'all',
                        children: [
                            {
                                path: '',
                                component: TasksAllComponent,
                            },
                            {
                                path: ':alias',
                                component: TasksAllComponent,
                            },
                            {
                                path: ':alias/:taskAlias',
                                component: TaskDetailComponent
                            },
                        ],
                    },
                    {
                        path: '',
                        children: [
                            {
                                path: 'options',
                                children: [
                                    {
                                        path: '',
                                        pathMatch: 'full',
                                        redirectTo: 'statuses',
                                    },
                                    {
                                        path: ':prop',
                                        canDeactivate: [ExitGuard],
                                        component: TaskOptionsComponent,
                                    },
                                ],
                            },
                            {
                                path: 'boards',
                                component: TaskBoardsComponent,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'assignments',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all',
                    },
                    {
                        path: 'all',
                        component: AllAssignmentsComponent,
                    },
                    {
                        path: 'all/:id',
                        component: DetailAssignmentsComponent,
                    },
                ]
            },
            {
                path: 'options',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'profile',
                    },
                    {
                        path: 'profile',
                        component: ProfileControlComponent,
                    },
                    {
                        path: 'properties',
                        component: PropertiesComponent,
                    },
                    {
                        path: 'catalogs',
                        component: CatalogsComponent,
                    },
                    {
                        path: 'menu',
                        canDeactivate: [ExitGuard],
                        component: SidebarSettingsComponent,
                    },
                    {
                        path: 'general',
                        component: GeneralProjectSettingsComponent,
                    },
                    {
                        path: '',
                        canActivate: [AdminGuard],
                        children: [
                            {
                                path: 'persons',
                                component: PersonsControlListComponent,
                            },
                            {
                                path: 'persons/:user_guid',
                                component: PersonsControlDetailComponent,
                            },
                            {
                                path: 'departments',
                                component: DepartmentsControlListComponent,
                            },
                            {
                                path: 'departments/:department_id',
                                component: DepartmentsControlDetailComponent,
                            },
                        ],
                    },
                ],
            },
            {
                path: 'finance',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'my',
                    },
                    {
                        path: 'my',
                        component: PersonalFinanceComponent,
                    },
                    {
                        path: '',
                        canActivate: [AdminGuard],
                        children: [
                            {
                                path: 'accounts',
                                component: FinanceControlComponent,
                            },
                            {
                                path: 'credit',
                                component: CreditComponent,
                            },
                            {
                                path: 'factoring',
                                component: FactoringComponent,
                            },
                            {
                                path: 'garant',
                                component: GarantComponent,
                            },
                        ],
                    },
                ],
            },

            {
                path: 'boxs',
                canActivate: [AdminGuard],
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'products',
                    },
                    {
                        path: 'products',
                        component: ProductsComponent,
                    },
                    {
                        path: 'storages',
                        component: StoragesComponent,
                    },
                ],
            },
            {
                path: 'contracts',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all',
                    },
                    {
                        path: 'detail/:guid',
                        canDeactivate: [ExitGuard],
                        component: AppContractFormComponent,
                    },
                    {
                        path: ':filter/:status',
                        component: AppMTContractTable,
                        data: {reuse: true}
                    },
                ],
            },
            {
                path: 'statistic',
                canActivate: [AdminGuard],
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'users',
                    },
                    {
                        path: 'users',
                        component: IndexStatisticComponent,
                    },
                    {
                        path: 'tasks',
                        component: IndexStatisticComponent,
                    },
                    {
                        path: 'finance',
                        component: IndexStatisticComponent,
                    },
                    {
                        path: 'contracts',
                        component: IndexStatisticComponent,
                    },
                ],
            },
            {
                path: 'production',
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'cards',
                    },
                    {
                        path: 'cards',
                        children: [
                            {
                                path: ':puid/:publicPuid',
                                component: PublicDetailCardComponent,
                            },
                            {
                                path: ':puid',
                                component: DetailCardComponent,
                            },
                            {
                                path: '',
                                component: ProductionCardListComponent,
                            },
                        ]
                    },
                    {
                        path: 'cargo',
                        component: CargoListComponent,
                    },
                    {
                        path: 'cargo_transaction',
                        component: CargoTransactionListComponent,
                    }
                ],
            },
            {
                path: 'template',
                canActivate: [() => !environment.production],
                children: [
                    {
                        path: '',
                        pathMatch: 'full',
                        redirectTo: 'all',
                    },
                    {
                        component: TemplateComponent,
                        path: 'all',
                    },
                ],
            },
        ],
    },
];

@NgModule({
    exports: [RouterModule],
    imports: [RouterModule.forRoot(routes)],
})
export class AppRoutingModule {
}
